// File: src/pages/candidate/TestListPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../css/HomePage.css'; 

// --- ICONS SVG ---
const IconTime = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>;
const IconBrain = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z"></path><path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z"></path></svg>;
const IconCode = () => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline></svg>;
const IconArrow = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>;
const IconLock = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>;
const IconSearch = () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>;
const IconFilter = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>;

export default function TestListPage() {
    const navigate = useNavigate();
    const [tests, setTests] = useState([]);
    const [loading, setLoading] = useState(true);
    
    // ✅ State cho Search & Filter
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedType, setSelectedType] = useState('ALL');
    const [selectedStatus, setSelectedStatus] = useState('OPEN'); // Mặc định chỉ hiện bài đang mở

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

    useEffect(() => {
        const fetchTests = async () => {
            try {
                const res = await fetch(`${apiBaseUrl}/api/public/tests`);
                if (res.ok) {
                    const data = await res.json();
                    setTests(data);
                }
            } catch (error) {
                console.error("Lỗi tải bài test:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchTests();
    }, [apiBaseUrl]);

    // Helper: Tính trạng thái thời gian thực
    const getTestStatus = (test) => {
        const now = new Date();
        const start = test.startDate ? new Date(test.startDate) : null;
        const end = test.endDate ? new Date(test.endDate) : null;

        if (start && now < start) return 'PENDING'; 
        if (end && now > end) return 'CLOSED';     
        return 'OPEN';                             
    };

    const formatDateTime = (dateString) => {
        if (!dateString) return '';
        return new Date(dateString).toLocaleDateString('vi-VN', {
            hour: '2-digit', minute: '2-digit', day: '2-digit', month: '2-digit'
        });
    };

    // ✅ LOGIC LỌC
    const filteredTests = tests.filter(test => {
        const status = getTestStatus(test);
        
        // 1. Lọc theo tên
        const matchName = test.assessmentName.toLowerCase().includes(searchTerm.toLowerCase()) || 
                          (test.createdBy?.companyName || '').toLowerCase().includes(searchTerm.toLowerCase());

        // 2. Lọc theo loại (MCQ, IQ, v.v.)
        const matchType = selectedType === 'ALL' || test.testType === selectedType;

        // 3. Lọc theo trạng thái
        let matchStatus = true;
        if (selectedStatus === 'OPEN') matchStatus = status === 'OPEN';
        if (selectedStatus === 'CLOSED') matchStatus = status === 'CLOSED';
        if (selectedStatus === 'PENDING') matchStatus = status === 'PENDING';

        return matchName && matchType && matchStatus;
    });

    return (
        <div className="homepage-wrapper">
            <main className="bbb">
                
                {/* ✅ HEADER + SEARCH BAR + FILTER */}
                <div className="search-header-container">
                    <div className="search-bg-decoration"></div>
                    <div className="header-content">
                        <h2 className="page-title">Kho bài kiểm tra năng lực</h2>
                        <p className="page-subtitle">Nâng cao hồ sơ của bạn với các bài test chuẩn hóa từ doanh nghiệp</p>

                        <div className="search-box-wrapper">
                            {/* Input Search */}
                            <div className="search-input-group flex-grow">
                                <span className="search-icon"><IconSearch /></span>
                                <input 
                                    type="text" 
                                    placeholder="Tìm kiếm bài test, công ty..." 
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>

                            <div className="divider"></div>

                            {/* Select Loại bài test */}
                            <div className="search-input-group" style={{ width: '150px' }}>
                                <span className="search-icon"><IconBrain style={{width: 18}}/></span>
                                <select value={selectedType} onChange={(e) => setSelectedType(e.target.value)} style={{cursor: 'pointer'}}>
                                    <option value="ALL">Tất cả loại</option>
                                    <option value="mcq">Trắc nghiệm</option>
                                    <option value="iq">IQ / Logic</option>
                                    <option value="coding">Lập trình</option>
                                    <option value="language">Ngôn ngữ</option>
                                </select>
                            </div>

                            <div className="divider"></div>

                             {/* Select Trạng thái */}
                             <div className="search-input-group" style={{ width: '160px' }}>
                                <span className="search-icon"><IconFilter /></span>
                                <select value={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)} style={{cursor: 'pointer'}}>
                                    <option value="ALL">Tất cả trạng thái</option>
                                    <option value="OPEN">Đang mở</option>
                                    <option value="PENDING">Sắp diễn ra</option>
                                    <option value="CLOSED">Đã kết thúc</option>
                                </select>
                            </div>

                        </div>
                    </div>
                </div>

                {/* ✅ KẾT QUẢ */}
                <div className="content-container">
                    <div className="results-meta">
                        Tìm thấy <span style={{fontWeight: 700, color: '#2563EB'}}>{filteredTests.length}</span> bài kiểm tra phù hợp
                    </div>

                    {loading ? (
                        <div style={{ textAlign: 'center', padding: 60, color: '#6B7280' }}>
                            <span className="material-symbols-outlined spin">sync</span> Đang tải dữ liệu...
                        </div>
                    ) : (
                        <div className="bento-grid">
                            {filteredTests.length > 0 ? (
                                filteredTests.map((test) => {
                                    const status = getTestStatus(test);
                                    
                                    return (
                                        <div key={test._id} className="bento-card" style={{ justifyContent: 'flex-start', gap: '16px', opacity: status === 'CLOSED' ? 0.7 : 1 }}>

                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                                <div className="logo-icon" style={{
                                                    background: test.testType === 'practical' ? '#F0F9FF' : '#EFF6FF',
                                                    color: test.testType === 'practical' ? '#0369A1' : '#2563EB',
                                                    width: 48, height: 48, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center'
                                                }}>
                                                    {test.testType === 'practical' ? <IconCode /> : <IconBrain />}
                                                </div>
                                                
                                                {status === 'PENDING' && <span className="tag" style={{ background: '#FEF3C7', color: '#D97706', textTransform: 'uppercase', fontSize: '10px', fontWeight: 700 }}>Sắp diễn ra</span>}
                                                {status === 'CLOSED' && <span className="tag" style={{ background: '#FEE2E2', color: '#DC2626', textTransform: 'uppercase', fontSize: '10px', fontWeight: 700 }}>Đã kết thúc</span>}
                                                {status === 'OPEN' && (
                                                    <span className="tag" style={{
                                                        background: test.testType === 'iq' ? '#F3E8FF' : (test.testType === 'mcq' ? '#DBEAFE' : '#DCFCE7'),
                                                        color: test.testType === 'iq' ? '#7E22CE' : (test.testType === 'mcq' ? '#1E40AF' : '#15803D'),
                                                        textTransform: 'uppercase', fontSize: '11px', fontWeight: 700
                                                    }}>
                                                        {test.testType}
                                                    </span>
                                                )}
                                            </div>

                                            <div style={{ flex: 1 }}>
                                                <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: '#111827', margin: '0 0 8px', lineHeight: 1.4 }}>{test.assessmentName}</h3>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 12 }}>
                                                    <span style={{ fontSize: '12px', fontWeight: 600, color: '#010101ff', background: '#EFF6FF', padding: '2px 8px', borderRadius: '4px' }}>
                                                        {test.createdBy?.companyName || 'Doanh nghiệp'}
                                                    </span>
                                                </div>
                                                <div className="flex flex-wrap gap-2 mb-4">
                                                    {test.tags && test.tags.length > 0 ? (
                                                        test.tags.map((tag, idx) => (
                                                            <span key={idx} className="px-2 py-1 bg-blue-50 text-blue-600 text-xs font-semibold rounded border border-blue-100">{tag}</span>
                                                        ))
                                                    ) : (
                                                        <span className="text-xs text-gray-400 italic">Kiến thức chung</span>
                                                    )}
                                                </div>
                                                
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 12, fontSize: '0.85rem', color: '#6B7280', fontWeight: 500 }}>
                                                    <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><IconTime /> {test.timeLimit} phút</span>
                                                    <span>•</span>
                                                    <span>{test.questions ? test.questions.length : 0} câu hỏi</span>
                                                </div>

                                                {(test.startDate || test.endDate) && (
                                                    <div style={{ marginTop: '8px', fontSize: '12px', color: '#4B5563', fontStyle: 'italic' }}>
                                                        {status === 'PENDING' && <span className="text-amber-600">Mở lúc: {formatDateTime(test.startDate)}</span>}
                                                        {status === 'OPEN' && test.endDate && <span className="text-green-600">Đóng lúc: {formatDateTime(test.endDate)}</span>}
                                                        {status === 'CLOSED' && <span className="text-red-600">Đóng lúc: {formatDateTime(test.endDate)}</span>}
                                                    </div>
                                                )}
                                            </div>

                                            <div style={{ paddingTop: 16, borderTop: '1px solid #E5E7EB', marginTop: 'auto' }}>
                                                {status === 'OPEN' ? (
                                                    <button
                                                        className="btn-primary"
                                                        onClick={() => navigate(`/candidate/tests/${test._id}`)}
                                                        style={{ width: '100%', display: 'flex', justifyContent: 'center', gap: 8, alignItems: 'center', padding: '10px' }}
                                                    >
                                                        Làm bài ngay <IconArrow />
                                                    </button>
                                                ) : (
                                                    <button
                                                        disabled
                                                        style={{ 
                                                            width: '100%', display: 'flex', justifyContent: 'center', gap: 8, alignItems: 'center', padding: '10px',
                                                            background: '#F3F4F6', color: '#9CA3AF', border: '1px solid #E5E7EB', borderRadius: '8px',
                                                            cursor: 'not-allowed', fontWeight: '600', fontSize: '14px'
                                                        }}
                                                    >
                                                        {status === 'PENDING' ? <> <IconLock /> Chưa đến giờ mở </> : <> <IconLock /> Đã kết thúc </>}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })
                            ) : (
                                <div className="no-results-box">
                                    <div style={{ fontSize: 40, marginBottom: 16 }}>📝</div>
                                    <p style={{ fontSize: 16, fontWeight: 600, color: '#374151' }}>Không tìm thấy bài test nào</p>
                                    <p style={{ color: '#6B7280', marginTop: 4 }}>Hãy thử thay đổi từ khóa hoặc bộ lọc</p>
                                    <button onClick={() => {setSearchTerm(''); setSelectedType('ALL'); setSelectedStatus('ALL')}}>Xóa bộ lọc</button>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </main>
            
            {/* CSS Tái sử dụng từ CompanyListPage (Đảm bảo có ở đây) */}
            <style>{`
                .homepage-wrapper { background: #F9FAFB; min-height: 100vh; }
                .bbb {
    
    /* Tách xa Navbar hơn */
    padding-bottom: 80px;
    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
    padding-left: 24px;
    padding-right: 24px;
    flex: 1;
    /* Đẩy footer xuống dưới cùng */
}
                .search-header-container {
                    background: linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%);
                    padding: 110px 24px 80px; text-align: center; position: relative; margin-bottom: 40px;
                    border-radius: 0 0 40px 40px; box-shadow: 0 4px 20px -5px rgba(37, 99, 235, 0.1);
                }
                .page-title { font-size: 28px; font-weight: 800; color: #1E40AF; margin-bottom: 8px; }
                .page-subtitle { color: #4B5563; margin-bottom: 32px; font-size: 16px; }

                .search-box-wrapper {
                    background: white; max-width: 900px; margin: 0 auto; border-radius: 16px; padding: 8px;
                    display: flex; align-items: center; box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1); border: 1px solid #E5E7EB;
                }
                .search-input-group { display: flex; align-items: center; padding: 0 1px; position: relative; }
                .flex-grow { flex: 1; }
                .search-icon { color: #9CA3AF; margin-right: 12px; display: flex; }
                .search-box-wrapper input, .search-box-wrapper select {
                    width: 100%; border: none; outline: none; font-size: 15px; color: #111827; padding: 12px 0; background: transparent;
                }
                .divider { width: 1px; height: 32px; background: #E5E7EB; margin: 0 8px; }

                .content-container { max-width: 1200px; margin: 0 auto; padding: 0 24px 60px; }
                .results-meta { margin-bottom: 24px; color: #6B7280; font-size: 14px; }
                .no-results-box {
                    grid-column: 1 / -1; text-align: center; padding: 60px; background: white; border-radius: 16px; border: 1px dashed #D1D5DB;
                }
                .no-results-box button {
                    margin-top: 16px; padding: 8px 16px; background: white; border: 1px solid #D1D5DB; border-radius: 6px; cursor: pointer; font-weight: 500;
                }
                @media (max-width: 768px) {
                    .search-box-wrapper { flex-direction: column; gap: 8px; padding: 16px; }
                    .search-input-group { width: 100% !important; }
                    .divider { display: none; }
                }
            `}</style>
        </div>
    );
}